<div class="avail-container" *ngIf="displayCalendar">
    <finder-component-header [data]="headerData"></finder-component-header>
    <div class="availability">
        <div [innerHTML]="data.labels.availability | safeHtml"></div>
        <finder-button anchor="true" (click)="handleFirstDate($event)" *ngIf="displayAvailability">
            {{data.labels.availabilitySearch}}
            <finder-font-icon class="navigation" svg="true" size="s" name="next-2"></finder-font-icon>
        </finder-button>
        <div class="phone-disclaimer" [innerHTML]="data.labels.phoneNumberDisclaimer | safeHtml"></div>
    </div>
    <div class="sliding-area">
        <div class="sticky-items">
            <div class="selectors">
                @defer {
                    <finder-ra-single-select
                        [options]="departureOptions"
                        [label]="data.labels.departureDropDown"
                        [value]="departureSelected"
                        (itemSelected)="handleDepartureChange($event, SELECTOR_TYPE.DEPARTURE)"
                    ></finder-ra-single-select>
                }
            </div>
            <div class="months">
                <finder-button
                    *ngIf="showPreviousArrow"
                    anchor="true"
                    [ariaLabel]="data.labels.previousMonth"
                    (click)="handleMonthChange(MONTH_DIRECTION.BACK, previousOutOfBounds)"
                >
                    <finder-font-icon
                        class="navigation"
                        svg="true"
                        size="m"
                        name="previous-2"
                    ></finder-font-icon>
                </finder-button>
                <div class="mobile">
                    <span class="month">{{monthStart}}</span> {{yearStart}}
                </div>
                <div class="desktop">
                    <span class="month">{{monthStart}}</span>
                    <span class="year" *ngIf="yearStart !== yearEnd">{{yearStart}}</span>
                    {{data.labels.dateSeperator}}
                    <span class="month">{{monthEnd}}</span>
                    <span class="year">{{yearEnd}}</span>
                </div>
                <finder-button
                    anchor="true"
                    *ngIf="showNextArrow"
                    [ariaLabel]="data.labels.nextMonth"
                    (click)="handleMonthChange(MONTH_DIRECTION.FORWARD)"
                >
                    <finder-font-icon
                        class="navigation"
                        svg="true"
                        size="m"
                        name="next-2"
                    ></finder-font-icon>
                </finder-button>
            </div>
            <div class="room-types" *ngIf="showRoomTypes">
                @defer {
                    <finder-ra-single-select
                        [options]="roomTypes"
                        [label]="data.labels.roomTypeLabel"
                        (itemSelected)="handleRoomSelection($event)"
                        value="all">
                    </finder-ra-single-select>
                }
            </div>
        </div>
        <div class="calendars" (click)="handleDateSelection($event)" (keyup)="handleDateSelection($event)">
            <finder-calendar *ngFor="let date of calendarDates"
                [sync]="false"
                [highlightDate]="false"
                [allowNavigation]="false"
                [maxDays]="1000"
                [displayYear]="false"
                [date]="date"
            >
            </finder-calendar>
            <div class="more-info" tabindex="0" *ngIf="displayMoreInfo">
                <div class="desktop booking-info">{{desktopInfoCopy}}</div>
                <div class="mobile booking-info">{{mobileInfoCopy}}</div>
                <div class="room-types-available" *ngIf="showRoomTypes" [innerHTML]="roomTypesAvailable | safeHtml"></div>
                <div class="call-for-booking">
                    <finder-font-icon svg="true" name="call" size="m" *ngIf="data.showPhoneIcon"></finder-font-icon>
                    <span [innerHtml]="data.labels.callToBook | safeHtml"></span>
                </div>
                <div class="hours" [innerHtml]="data.labels.tripDisclaimer | safeHtml"></div>
                <finder-button anchor="true" (click)="handleClearDates($event)">
                    {{data.labels.clearDates}}
                </finder-button>
            </div>
        </div>
    </div>
    <div class="calendar-keys" [ngClass]="{'single-key': !displayAvailability}">
        <div class="example" *ngIf="!displayAvailability">
            <div class="available-departure">1</div>
            <div class="description">{{data.labels.calendarKeyVoyageDeparture}}</div>
        </div>
        <div class="example" *ngIf="displayAvailability">
            <div class="available-departure">1</div>
            <div class="description">{{data.labels.calendarKeyAvailableDeparture}}</div>
        </div>
        <div class="example" *ngIf="showLimitedAvailability">
            <div class="available-departure limited-availability">1</div>
            <div class="description">{{data.labels.limitedAvailability}}</div>
        </div>
        <div class="example" *ngIf="!showLimitedAvailability && displayAvailability">
            <div class="not-available">1</div>
            <div class="description">{{data.labels.calendarKeyNotAvailable}}</div>
        </div>
        <div class="example" *ngIf="displayAvailability">
            <div class="available-selected">1</div>
            <div class="description">{{data.labels.calendarKeySelected}}</div>
        </div>
    </div>
    <div class="disclaimer">
        {{data.labels.lastUpdate}}<br/>
        {{data.labels.disclaimer}}
    </div>
</div>
